import { axiosHelper } from 'Services/AxiosHelper';
import { OnGetShippingLocationInfoListModel } from 'Models';
import { onGetShippingLocationInfoListBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGetShippingLocationInfoList';

const onGetShippingLocationInfoList = async (
  params: onGetShippingLocationInfoListBodyData
): Promise<OnGetShippingLocationInfoListModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetShippingLocationInfoList;
